export default __webpack_public_path__ + "static/media/19-CSA.98c831c0.jpg";